export class AuthCredential {
  constructor(
    public readonly accessToken?: string,
    public readonly refreshToken?: string,
    public readonly idToken?: string,
    public readonly session?: string,
    public readonly challengeName?: string,
    public readonly email?: string,
    public readonly localAuth?: boolean
  ) {}
}
